export enum RedeemStepsE {
  START_ALLOWANCE = 'START_ALLOWANCE',
  CHECK_ALLOWANCE = 'CHECK_ALLOWANCE',
  SUBMIT_ALLOWANCE = 'SUBMIT_ALLOWANCE',
  WAIT_ALLOWANCE = 'WAIT_ALLOWANCE',
  SUBMIT_REDEEM = 'SUBMIT_REDEEM',
  WAIT_REDEEM = 'WAIT_REDEEM',
  BURN_IN_PROGRESS = 'BURN_IN_PROGRESS',
  NFT_BURNED = 'NFT_BURNED',
}

export enum ModalTitleE {
  ACCESS,
  APPROVAL,
  BURN_NFT,
  NFT_BURNED,
}

export enum ModalDescriptionE {
  WAIT,
  CHECK_EMAIL,
}

export enum IconE {
  STOPWATCH_ICON,
  FIRE_ICON,
  FIRE_WORK_ICON,
}

export interface RedeemProgressStepI {
  modalTitle: string
  description: string
  icon: string | JSX.Element
  progress?: number
  component?: JSX.Element | null
}
